import React, { useEffect, useRef, useState } from "react";
import NavBar from "../../../Components/Navbar/navbar";
import styles from "../../Styles/tables.module.css";
import { HiPencil, HiPlus, HiSearch, HiTrash, HiX } from "react-icons/hi";
import { useLocation, useNavigate } from "react-router";
import axios from "axios";
import { getUser, Url, UrlAFACARD } from "../../../Constants/globals";
import RefreshToken from "../../../Components/RefreshToken/RefreshToken";
import DeleteModal from "../../../Components/DeleteModal/deletemodal";
import Alert from "../../../Components/Alert/alert";
import GoBack from "../../../Components/GoBack/goback";

function EmpresasCartoes({ userPermissions }) {

    const location = useLocation();
    const { state } = location;
    const navigate = useNavigate();
    const searchRef = useRef(null);

    const [loading, setLoading] = useState("");
    const [loadingData, setLoadingData] = useState(true);
    const [deleteCard, setDeleteCard] = useState("");
    const [cardsCompanies, setCardsCompanies] = useState([]);
    const [alert, setAlert] = useState("");
    const [isPoppedOut, setIsPoppedOut] = useState(false);
    const [nomeSearch, setNomeSearch] = useState(state?.nomeSearch ? state.nomeSearch : "");
    const [showSearch, setShowSearch] = useState(nomeSearch ? true : false);

    async function getEmpresaCards(name) {
        try {
            const res = await axios.get(`${UrlAFACARD}/companies${name ? `?search=${name}` : ""}`, {
                headers: {
                    Authorization: "Bearer " + getUser().token,
                },
            });
            return res.data;
        }
        catch (err) {
            if (err.request && err.request.status === 401) {
                var newToken = await RefreshToken(err);
                if (newToken) return await getEmpresaCards(name);
                else window.location.reload();
            }
            else {
                console.error(err);
                return "";
            }
        };
    }

    async function deleteCardCompanyFunction(id) {
        try {
            await axios.delete(`${UrlAFACARD}/companies/${id}`, {
                headers: {
                    Authorization: "Bearer " + getUser().token,
                },
            });
            return [200, <Alert type={"success"}>Empresa eliminada com sucesso!</Alert>];
        }
        catch (err) {
            if (err.request && err.request.status === 401) {
                var newToken = await RefreshToken(err);
                if (newToken) return await deleteCardCompanyFunction(id);
                else window.location.reload();
            }
            else {
                console.error(err);
                return [0, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao eliminar a empresa"}</Alert>];
            }
        };
    }

    async function getAlertDelete(id) {
        if (id) {
            await setAlert("");
            const res = await deleteCardCompanyFunction(id);
            setAlert(res[1]);
            assignData();
            return res;
        }
    }

    async function assignData() {
        const thisCardsData = await getEmpresaCards();
        setCardsCompanies(thisCardsData?.items?.length ? thisCardsData.items : []);
        setLoadingData(false);
    }

    const handleSearchContainer = () => {
        if (showSearch) {
            setIsPoppedOut(true);
            setTimeout(() => {
                setShowSearch(false);
                setIsPoppedOut(false);
            }, 280);
        } else {
            setShowSearch(true);
            setTimeout(() => {
                searchRef.current.focus();
            }, 280);
        }
    }

    async function handleSearch(input) {
        if (input === false) {
            setNomeSearch("");
        }
        const searchCardsData = await getEmpresaCards(input === false ? "" : nomeSearch);
        setCardsCompanies(searchCardsData?.items?.length ? searchCardsData.items : []);
        navigate(location.pathname, { replace: true, state: { nomeSearch: input === false ? "" : nomeSearch } });
    }

    useEffect(() => {
        assignData();
    }, []);

    return (
        <div className="body">
            {alert}
            {loading}
            {deleteCard}
            <NavBar current={"empresas"} setDisappear={setLoadingData} userPermissions={userPermissions} />
            {
                userPermissions.empresas ? <GoBack backRoute={`/empresas`} backState={state?.page ? { page: state.page, nomeSearch: state.nomeSearch ?? "" } : {}} /> : ""
            }
            {
                loadingData ? ""
                    :
                    <div style={{ position: "relative" }}>
                        <div className={styles.tableButtons}>
                            <button className={styles.btnAdd} onClick={() => navigate("/empresas-cartoes/adicionar")}>
                                <HiPlus size={20} />
                                <p className={styles.textAdd}>Adicionar</p>
                            </button>
                            <button className={`${styles.btnSearch} ${showSearch ? styles.btnSearchActive : ""}`} onClick={() => handleSearchContainer()}>
                                <HiSearch size={20} />
                                <p className={styles.textAdd}>Procurar</p>
                            </button>
                        </div>
                        <div className={styles.content}>
                            {
                                showSearch ?
                                    <div className={`${styles.container} ${showSearch ? styles.popin : ""} ${isPoppedOut ? styles.popout : ""}`}>
                                        <input
                                            ref={searchRef}
                                            className={styles.searchInput}
                                            onChange={(e) => setNomeSearch(e.target.value)}
                                            placeholder="Procurar empresa"
                                            value={nomeSearch}
                                            onKeyDown={(event) => {
                                                if (event.key === "Enter") handleSearch();
                                            }}
                                        />
                                        <div style={{ backgroundColor: "var(--inputBackground)", display: "flex", borderTopRightRadius: "4px", borderBottomRightRadius: "4px" }}>
                                            <button className={styles.btn} style={{ cursor: "default", marginRight: "0" }} onClick={() => handleSearch(false)}>
                                                <HiX size={16} color="#9c9c9c" />
                                            </button>
                                            <button className={styles.btn} style={{ marginLeft: "0" }} onClick={() => handleSearch()}>
                                                <HiSearch size={18} />
                                            </button>
                                        </div>
                                    </div>
                                    : ""
                            }
                            <div className={styles.table}>
                                <div className={styles.companiesColumn}>
                                    <p></p>
                                    <p>Nome</p>
                                    <p>Cores</p>
                                    <p>Ações</p>
                                </div>
                                <div className={styles.scrollContent}>
                                    {
                                        cardsCompanies.length ?
                                            cardsCompanies.map((c, index) =>
                                                <div key={index} className={styles.companiesInfo} style={index % 2 !== 0 ? { backgroundColor: "var(--inputBackground)" } : {}}>
                                                    {
                                                        c.logo_url ?
                                                            <img className={styles.foto} alt="img" src={`${UrlAFACARD}/${c.logo_url}`} />
                                                            :
                                                            <p>-</p>
                                                    }
                                                    <p title={c.name ? c.name : ""}>
                                                        {c.name ? c.name : "-"}
                                                    </p>
                                                    <div className={styles.colorBox}>
                                                        <div style={{ boxShadow: "0 0 5px 3px #00000020", borderRadius: "6px", overflow: "hidden" }}>
                                                            <div style={{ backgroundColor: c.secondary_color }} className={styles.secondColor} />
                                                            <div style={{ backgroundColor: c.primary_color }} className={styles.firstColor}>
                                                                <p style={{ margin: 0, color: c.text_color }}>Texto</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={styles.actions}>
                                                        <HiPencil
                                                            size={22}
                                                            className={styles.icon}
                                                            onClick={() => navigate(`/empresas-cartoes/${c.id}`)}
                                                        />
                                                        <HiTrash
                                                            size={22}
                                                            className={styles.icon}
                                                            onClick={() => setDeleteCard(<DeleteModal close={setDeleteCard} objectId={c.id} objectName={c.name} deleteFunction={getAlertDelete} />)}
                                                        />
                                                    </div>
                                                </div>
                                            )
                                            :
                                            <div className={styles.noData}>
                                                <p>Não existem dados</p>
                                            </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
            }
        </div>
    );
}

export default EmpresasCartoes;